import Richtext from './richtext';

export default class Message {
  backgroundColor?: string;
  description?: Richtext;

  constructor(props: any) {
    if (!props) return;

    this.backgroundColor = props.backgroundColor;
    this.description = props.description
      ? new Richtext(props.description)
      : undefined;
  }
}
